<template>
  <!-- 富文本 -->
  <quill-editor
    ref="myQuillEditor"
    v-model="content"
    :options="editorOption"
  ></quill-editor>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import {
  ImageExtend,
  QuillWatch,
} from '@/assets/script/quill-image-extend-module/index.js'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
import storage from 'good-storage'
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
import { ERR_OK, LOGIN_EXPIRED } from 'config/index'
export default {
  name: 'QuillEditor',
  data() {
    return {
      content: this.initContent,
      editorOption: {
        placeholder: '请输入...',
        modules: {
          toolbar: {
            container: [
              [{ size: ['small', false, 'large'] }],
              ['bold', 'italic'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link', 'image'],
            ],
            handlers: {
              image: function() {
                QuillWatch.emit(this.quill.id)
              },
            },
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
          ImageExtend: {
            size: this.maxImageSize, // 单位为M, 1M = 1024KB
            sizeError: () => {
              this.$notification.error(`上传图片不能大于${this.maxImageSize}M`)
            },
            loading: true,
            name: 'file',
            action: '/credit/bp/approve/image/upload',
            headers: xhr => {
              xhr.setRequestHeader('token', this.token)
            },
            response: res => {
              const { code, message } = res
              if (code == LOGIN_EXPIRED) {
                // 此时登录过期
                this.$notification.error({
                  message: '提示',
                  description: message || '登录过期，请重新登录',
                })
                window.setTimeout(() => {
                  storage.clear()
                  this.$router.push('/login')
                }, 1000)
              }
              if (code != ERR_OK) {
                this.$notification.error({
                  message: '提示',
                  description: message,
                })
                return
              }
              return res.data
            },
          },
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
        },
      },
    }
  },
  props: {
    maxImageSize: {
      type: Number,
      default: 2, // 单位为M
    },
    initContent: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
  },
  methods: {
    onValid() {
      return this.content.trim()
    },
    clearContent() {
      this.content = ''
    },
    // 暴露给父组件的方法
    getContent() {
      return this.content
    },
  },

  components: {
    quillEditor,
  },
}
</script>

<style lang="less">
.quill-editor {
  line-height: 1.3;
}
.quill-editor .ql-container .ql-editor {
  height: 20rem;
}
</style>
